export default __webpack_public_path__ + "static/media/imglinkedin.68ac41e1.png";